import {
  WorkOrderSortOption,
  WorkOrderStatus,
} from '@rematter/frontend-lib-api-client';

import { WorkOrderRecord } from '../types/workOrder';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type WorkOrderSummaryStats = {
  total: number;
  draft: number;
  open: number;
  inProgress: number;
  completed: number;
  cancelled: number;
};

export const workOrdersQueryAtom = createQueryAtomFactory(
  'production.workOrders',
  (params: {
    searchTerm?: string;
    status?: WorkOrderStatus[];
    processingTypeIds?: string[];
    facilityIds?: string[];
    limit?: number;
    offset?: number;
    sorting?: WorkOrderSortOption[];
  }) => ({
    workOrders: {
      __args: {
        filter: {
          searchTerm: params.searchTerm,
          status: params.status,
          processingTypeIds: params.processingTypeIds,
          facilityIds: params.facilityIds,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 25,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        workOrderNumber: true,
        status: true,
        processingTypeId: true,
        processingType: {
          id: true,
          name: true,
          code: true,
        },
        facilityId: true,
        facility: {
          id: true,
          facilityName: true,
        },
        scheduledStartDate: true,
        scheduledEndDate: true,
        actualStartDate: true,
        actualEndDate: true,
        notes: true,
        tollingType: true,
        outboundTollingAgreementId: true,
        inboundTollingAgreementId: true,
        createdBy: true,
        createdByUser: {
          id: true,
          firstName: true,
          lastName: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (
      data,
    ): {
      workOrders: WorkOrderRecord[];
      totalCount: number;
    } => {
      if (!data?.workOrders?.entries) {
        return {
          workOrders: [],
          totalCount: 0,
        };
      }

      return {
        workOrders: data.workOrders.entries.map((wo) => ({
          id: wo.id,
          workOrderNumber: wo.workOrderNumber,
          status: wo.status,
          processingTypeId: wo.processingTypeId,
          processingTypeName: wo.processingType?.name,
          processingTypeCode: wo.processingType?.code,
          facilityId: wo.facilityId,
          facilityName: wo.facility?.facilityName,
          scheduledStartDate: wo.scheduledStartDate ?? undefined,
          scheduledEndDate: wo.scheduledEndDate ?? undefined,
          actualStartDate: wo.actualStartDate ?? undefined,
          actualEndDate: wo.actualEndDate ?? undefined,
          notes: wo.notes ?? undefined,
          isTolling: wo.tollingType !== 'None',
          tollingType: wo.tollingType,
          outboundTollingAgreementId:
            wo.outboundTollingAgreementId ?? undefined,
          inboundTollingAgreementId: wo.inboundTollingAgreementId ?? undefined,
          createdById: wo.createdBy ?? '',
          createdByName:
            wo.createdByUser?.firstName && wo.createdByUser?.lastName
              ? `${wo.createdByUser.firstName} ${wo.createdByUser.lastName}`
              : undefined,
          inputItems: [],
          outputItems: [],
          createdAt: wo.timestamps.createdAt,
          updatedAt: wo.timestamps.updatedAt,
        })),
        totalCount: data.workOrders.page?.total ?? 0,
      };
    },
  },
);
